/**
 * Subscription sagas
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { httpRequest } from '../../services/http-service';
import { endPoints } from '../../services/endpoints';
import {
  fetchSubscriptionAnalytics,
  setSubscriptionAnalytics,
  setLoading,
  setError,
} from './subscriptionSlice';
import { presentLoader, dismissLoader } from './commonSlice';

/**
 * Fetch subscription analytics saga
 */
function* fetchSubscriptionAnalyticsSaga(): Generator<any, void, any> {
  try {
    yield put(presentLoader());
    yield put(setLoading(true));

    const response = yield call(httpRequest.get, endPoints.dashboard.subscriptionAnalytics);

    if (response?.success) {
      yield put(setSubscriptionAnalytics(response.data));
    } else {
      toast.error('Failed to fetch subscription analytics');
      yield put(setError('Failed to fetch subscription analytics'));
    }
  } catch (error: any) {
    const message = error?.message || 'Failed to fetch subscription analytics';
    toast.error(message);
    yield put(setError(message));
  } finally {
    yield put(setLoading(false));
    yield put(dismissLoader());
  }
}

export function* subscriptionSagas(): Generator<any, void, any> {
  yield takeLatest(fetchSubscriptionAnalytics, fetchSubscriptionAnalyticsSaga);
}

